/* eslint-disable */
import createIcon from '../createIcon';

const IconArrowUpOutlined = createIcon({
  name: 'icon-arrow-up-outlined',
  content: '<path d="M197.408 509.515l315.42-315.42 45.051 45.05-315.42 315.42z"/><path d="M783.134 553.483l-315.357-315.42 45.051-44.988 315.42 315.42z"/><path d="M544.18 258.07v637.213h-63.722V258.071z"/>',
  width: 1024,
  height: 1024
});
export default IconArrowUpOutlined;
